const semanticClassNames = {
  root: 'accordion',
  title: 'accordion__title',
  container: 'accordion__container',
  item: 'accordion__item',
  icon: 'accordion__icon',
} as const;

export default semanticClassNames;
